var map = {
	"./bot-icon.svg": 8929,
	"./check-arrow.svg": 99342,
	"./close.svg": 95734,
	"./doc.svg": 23776,
	"./excel.svg": 77995,
	"./hotshape/canvas.svg": 89817,
	"./hotshape/flowchart.svg": 75823,
	"./hotshape/list.svg": 65061,
	"./hotshape/mindmap.svg": 52101,
	"./hotshape/pest.svg": 86669,
	"./hotshape/portrait.svg": 31400,
	"./hotshape/story.svg": 24908,
	"./hotshape/swot.svg": 24094,
	"./hotshape/table.svg": 92347,
	"./hotshape/timeline.svg": 48052,
	"./loading.svg": 32606,
	"./menu/canvas.svg": 50698,
	"./menu/flowchart.svg": 71478,
	"./menu/list.svg": 75010,
	"./menu/mind.svg": 18730,
	"./menu/pest.svg": 97106,
	"./menu/swot.svg": 85293,
	"./menu/table.svg": 69594,
	"./menu/table_analysis.svg": 84975,
	"./menu/timeline.svg": 50299,
	"./menu/user_portrait.svg": 77487,
	"./menu/user_story.svg": 90545,
	"./pdf.svg": 44788,
	"./point-icon.svg": 14725,
	"./question.svg": 4746,
	"./quit-circle.svg": 50844,
	"./quit.svg": 32351,
	"./replace.svg": 74742,
	"./send.svg": 90484,
	"./talk-on.svg": 39110,
	"./talk.svg": 48504,
	"./tcase01.svg": 29775,
	"./tcase02.svg": 27452,
	"./tcase03.svg": 55997,
	"./textcheck-null.svg": 68117,
	"./title-icon.svg": 66506,
	"./txt.svg": 64414,
	"./upload.svg": 69473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70944;